import { MetadataDto } from './metadatadto';
export class Metadata4RefDto {
    packageHeader: MetadataPackageHeader;
    metadata: MetadataDto;
}

export class MetadataPackageHeader {
    name: string;
    version: MetadataPackageVersion;
    location: string;
}

export class MetadataPackageVersion {
    versionString: string;
}
